import $ from 'jquery';

// Expose jQuery on window so jQuery plugins (parsleyjs, magnific-popup, …)
// that look for `window.jQuery` / `window.$` keep working without webpack's ProvidePlugin.
window.$ = window.jQuery = $;

import 'parsleyjs';
import './Language/parsley';
import './Libraries/emailDecrypt';

import './General/Setup';
import './General/Lightbox';
import './General/Select';
import './General/Menu';
import './General/Datepicker';
import './General/SmoothScroll';
import './General/TwoClick';
// import './General/LangMenu';

import './ContentBlocks/Slider';
import './ContentBlocks/Gallery';
import './ContentBlocks/Youtube';
import './ContentBlocks/Maps';
import './ContentBlocks/Accordion';

// just a simple resize trigger. Nice to have.
$(window).trigger('resize');
